import dayjs from "dayjs";
import { defaultAgenciesCurrencies } from "src/shared/constants/company.constants";
import { EAgencies } from "src/shared/types/common.types";
import { ECurrency } from "src/shared/types/currency.types";
import {
  EContractState,
  EOriginalAvailability,
  ETaxSystem,
} from "src/shared/types/partner.types";
import {
  IAgreementFormValues,
  IPartnerComplexContractFormValues,
  IPartnerVirtualContractFormValues,
} from "../types";

export const getPartnerComplexContractDefaultFormValues = ({
  agency,
}: {
  agency?: EAgencies;
}): IPartnerComplexContractFormValues => ({
  contract_number: "",
  contract_date: dayjs(),
  partner_id: "",
  site: "",
  contract_email: "",
  contract_state: EContractState._0,
  currency: agency ? defaultAgenciesCurrencies[agency] : ECurrency.BYN,
  tax_value: 0,
  tax_system: ETaxSystem._1,
  original_availability: EOriginalAvailability.ABSENT,
  contract_manager: "",
  context_teamlead: "",
  account_manager: "",
  note: "",
  partner_bonus_min_sum: 100,
  has_tax_certificate: false,
  tax_certificate_path: "",
  contract_original_file_path: "",
  with_edits: false,
  edit_notes: "",
  customer_info: {
    represented_by: "",
    bases_on: "",
    signs: "",
    position: "",
  },
  executor_info: {
    represented_by: "",
    position: "",
    bases_on: "",
    signs: "",
  },
});

export const getVirtualContractDefaultFormValues = ({
  partner_id,
}: {
  partner_id: number | string;
}): IPartnerVirtualContractFormValues => ({
  partner_id: Number(partner_id),
  id: 0,
  service_currency: "",
  state: EContractState._0,
  site: "",
  partner_contract_id: "",
  service_name: "",
  contract_date: dayjs(),
  contract_number: "",
  note: "",
  is_bonus_enabled: false,
});

export const agreementDefaultFormValues: IAgreementFormValues = {
  data: {
    agreement_date: dayjs(),
    note: "",
    is_active: false,
    is_original_presented: true,
    is_agreement_with_edits: false,
  },
  file: null,
};
